import {Map, Seq, List} from 'immutable';

import {myRemoveEntities, myRemoveEntitiesBySport} from './utils';

import {LIVE_INIT, LIVE_UPDATE} from 'sagas/actions';

import * as LiveActions from 'actions/Live';
import * as LineActions from 'actions/Line';
import * as ExpandActions from 'actions/Expand';
import * as CollapseActions from 'actions/Collapse';
import * as ToggleGroupActions from 'actions/ToggleGroup';
import * as StakeOfTheDayActions from 'actions/StakeOfTheDay';
import * as PopularActions from 'actions/Popular';

import groupOutcomeTypes from '../../glossary/group-headers.json';
import Axios from 'axios';

export default function groupsReducer(groups, action, outcomes, matches) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
        case LineActions.CLEAR_LINE:
            return new Map();

        case LIVE_INIT.SUCCESS:
        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
            return setGroups(new Map(), action.data.groups.add, outcomes, matches);

        case LIVE_UPDATE.SUCCESS:
            return update(groups, outcomes, matches, action.data);

        case LineActions.SUCCESS_REQUEST_FULL_LINE:
            groups = setGroups(groups, action.data.groups.add, outcomes, matches);
            return expandMatchGroups(groups, action.data.events.add);

        case ExpandActions.EXPAND_ALL_GROUPS:
            return expandAllGroups(groups);

        case CollapseActions.COLLAPSE_ALL_GROUPS:
            return collapseAllGroups(groups);

        case ToggleGroupActions.TOGGLE_GROUP:
            return toggleGroup(groups, action.data);

        case ToggleGroupActions.EXPAND_GROUP:
            return toggleExpandGroup(groups, action.data);
    }

    return groups;
}

function update(groups, outcomes, matches, data) {

    if (data.sports !== undefined && data.sports.remove !== undefined) {
        groups = myRemoveEntitiesBySport(groups, 'sportId', data.sports.remove);
    }

    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
        groups = myRemoveEntities(groups, 'leagueId', data.leagues.remove);
    }

    if (data.events !== undefined && data.events.remove !== undefined) {
        groups = myRemoveEntities(groups, 'matchId', data.events.remove);
    }

    if (data.outcomes !== undefined) {
        groups = removeGroupOutcomes(groups, outcomes, data.outcomes.remove);
        groups = setGroups(groups, data.groups.add, outcomes, matches);
        groups = updateGroups(groups, outcomes, data.groups.change);
    }

    return groups;
}

function removeGroupOutcomes(groups, outcomes, outcomesToRemove) {
    if (outcomesToRemove === undefined) {
        return groups;
    }

    for (let i = 0; i < outcomesToRemove.length; i++) {
        const outcomeId = outcomesToRemove[i].id;
        const groupWithOutcome = groups.find(g => g.get('outcomes').includes(outcomeId));

        if (groupWithOutcome) {
            const id = groupWithOutcome.get('id');
            if (groupWithOutcome.get('outcomes').size === 1) {
                groups = groups.delete(id);
            } else {
                groups = groups.updateIn([id, 'outcomes'], (g) => {
                    const index = g.indexOf(outcomeId);
                    return g.remove(index);
                });
            }
        }
    }

    return groups;
}

function updateGroups(groups, outcomes, changedGroups) {
    if (outcomes === undefined || changedGroups === undefined) {
        return groups;
    }

    for (let i = 0; i < changedGroups.length; i++) {
        const changedGroup = changedGroups[i];

        const group = groups.get(changedGroup);
        if (group) {
            const filtered = outcomes.filter(o => o.get('groupId') === changedGroup).toArray();
            if (filtered) {
                const headers = filtered.filter(o => o.get('isHeader') === true);

                ((groupId, groupHasBody, groupOutcomes) => {
                    groups = groups.update(groupId, (g) => {
                        return g.set('hasBody', groupHasBody).set('outcomes', groupOutcomes);
                    })
                })(changedGroup, filtered.length > headers.length, List(filtered.map(o => o.get('id'))));
            }
            else {
                (groupId => {
                    groups = groups.update(groupId, (g) => {
                        return g.set('hasBody', false).set('outcomes', new List());
                    })
                })(changedGroup);
            }
        }
    }

    return groups;
}

function setGroups(groups, addedGroups, outcomes, matches) {
    if (outcomes === undefined ) {
        return groups;
    }

    for (let i = 0; i < addedGroups.length; i++) {
        const addedGroup = addedGroups[i];

        const match = matches.get(addedGroup.matchId);

        let group = groups.get(addedGroup.id);
        if (!group) {

            const sportGroups = groupOutcomeTypes[match.get('realSportId')];
            const groupConfig = sportGroups[addedGroup.type];

            group = new Map();

            group = group.set('sportId', addedGroup.sportId);
            group = group.set('realSportId', match.get('realSportId'));
            group = group.set('leagueId', addedGroup.leagueId);
            group = group.set('matchId', addedGroup.matchId);
            group = group.set('isClosed', false);
            group = group.set('type', addedGroup.type);
            group = group.set('id', addedGroup.id);
            group = group.set('parentId', groupConfig.parent);
            group = group.set('priority', groupConfig.priority);
            group = group.set('isExpanded', false);
        }

        if (!(addedGroup.type === 0 && groups.has(addedGroup.id))) {
            group = group.set('isClosed', true);
        }

        group = group.set('hasBody', false);
        group = group.set('outcomes', new List());

        const filtered = outcomes.filter(o => o.get('groupId') === addedGroup.id).toArray();
        if (filtered)
        {
            const headers = filtered.filter(o => o.get('isHeader') === true);
            if (filtered.length > headers.length) {
                group = group.set('hasBody', true);
            }

            group = group.set('outcomes', List(filtered.map(o => o.get('id'))));
        }

        groups = groups.set(addedGroup.id, group);
    }

    return groups;
}

function toggleGroup(groups, groupId) {
    return groups.updateIn([groupId], g => {
        const isClosed = !g.get('isClosed')

        if (g.get('isClosed')) {
            try {
                Axios.post(`/api/actions/set?type=expand`)
            } catch (error) {}
        }

        return g.set('isClosed', isClosed);
    });
}

function expandAllGroups(groups) {
    return Seq(groups).map(g => {
        g = g.set('isExpanded', true);
        return g.set('isClosed', false);
    }).toMap();
}

function collapseAllGroups(groups) {
    return Seq(groups).map(g => {
        g = g.set('isExpanded', false);
        return g.set('isClosed', true);
    }).toMap();
}

function expandMatchGroups(groups, loadedMatches) {
    if (loadedMatches.length === 0) {
        return groups;
    }

    for (let i = 0; i < loadedMatches.length; i++) {
        const matchId = loadedMatches[i].id;

        const matchGroups = groups.filter((g) => g.get('type') === 0 && g.get('matchId') === matchId);
        const matchGroupIds = matchGroups.map((g) => g.get('id')).toArray();

        for (let j = 0; j < matchGroupIds.length; j++) {
            const groupId = matchGroupIds[j];

            groups = groups.updateIn([groupId, 'isClosed'], () => false);
        }
    }

    return groups;
}

function toggleExpandGroup(groups, groupId) {
    return groups.updateIn([groupId], g => {
        return g.set('isExpanded', !g.get('isExpanded'));
    })
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/groupsReducer.js